import React, { useState } from 'react';
import SubscriptionForm from '../../../components/ui/SubscriptionForm';
import Icon from '../../../components/AppIcon';

const SubscribeSection = () => {
  const [showModal, setShowModal] = useState(false);

  const handleSubscribe = async (formData) => {
    console.log('Subscription data:', formData);
    await new Promise(resolve => setTimeout(resolve, 1500));
  };

  const openModal = () => {
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setShowModal(false);
    document.body.style.overflow = 'unset';
  };

  return (
    <>
      <section id="subscribe-section" className="py-16 lg:py-24 bg-gradient-to-br from-primary via-primary/95 to-secondary">
        <div className="max-w-4xl mx-auto px-5 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white text-sm font-medium mb-6">
              <Icon name="Sparkles" size={16} />
              <span>Join Our Community</span>
            </div>

            <h2 className="text-3xl lg:text-4xl font-heading font-bold text-white mb-4">
              Ready to Stay Informed?
            </h2>
            <p className="text-lg text-white/90 max-w-2xl mx-auto">
              Subscribe now and receive weekly funding opportunities, agency insights, and expert tips directly in your inbox
            </p>
          </div>

          <div className="bg-card rounded-xl shadow-elevation-lg p-8 lg:p-10">
            <SubscriptionForm onSubmit={handleSubscribe} onClose={closeModal} />
          </div>

          <div className="flex items-center justify-center gap-8 mt-8 text-white/80 text-sm">
            <div className="flex items-center gap-2">
              <Icon name="Lock" size={16} />
              <span>Secure & Private</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Mail" size={16} />
              <span>No Spam Ever</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="X" size={16} />
              <span>Unsubscribe Anytime</span>
            </div>
          </div>
        </div>
      </section>
      {showModal && (
        <div
          className="fixed inset-0 z-[200] flex items-center justify-center bg-foreground/60 backdrop-blur-sm animate-fade-in"
          onClick={closeModal}
        >
          <div
            className="bg-card rounded-xl shadow-elevation-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto"
            onClick={(e) => e?.stopPropagation()}
          >
            <div className="sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-heading font-semibold text-foreground">
                Subscribe to THEPS Newsletter
              </h3>
              <button
                onClick={closeModal}
                className="flex items-center justify-center w-8 h-8 text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors duration-250"
                aria-label="Close modal"
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            <div className="p-6">
              <SubscriptionForm
                onSubmit={handleSubscribe}
                isModal={true}
                onClose={closeModal}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SubscribeSection;